import Swiper from 'swiper';
import { Pagination, Autoplay, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

const statsSliders = document.querySelectorAll('.stats-slider__inner.swiper');
const splitImageSliders = document.querySelectorAll('.split-image__slider.swiper');

for (let i = 0; i < statsSliders.length; i++) {
    const statsSlider = new Swiper(statsSliders[i], {
        modules: [Pagination],
        slidesPerView: 1,
        loop: true,
        direction: 'vertical',
        autoHeight: true,
        pagination: {
            el: statsSliders[i].parentElement.querySelector('.stats-slider__pagination'),
            clickable: true,
            renderBullet: function (index, className) {
                return '<button class="' + className + '"><span class="inner"><span class="visually-hidden">Slide '+index+'</span></span></button>';
            },
            type: 'bullets',
            bulletClass: 'stats-slider__pagination-bullet',
            bulletActiveClass: 'stats-slider__pagination-bullet-active',
            bulletElement: 'button',
        },
        on: {
            slideChange: function () {
                this.el.style.height = setHeight(this.el) + 'px';
            },
            init: function () {
                this.el.style.height = setHeight(this.el) + 'px';
            },
            resize: function () {
                this.changeDirection(getDirection());
            }
        }
    });
}

for (let i = 0; i < splitImageSliders.length; i++) {
    const splitImageSlider = new Swiper(splitImageSliders[i], {
        modules: [Autoplay, EffectFade, Pagination],
        allowTouchMove: false,
        slidesPerView: 1,
        loop: true,
        autoplay: {
            delay: 4000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
        },
        pagination: {
            el: splitImageSliders[i].parentElement.querySelector('.swiper-pagination'),
            clickable: true,
            renderBullet: function (index, className) {
                return '<button class="' + className + '"><span class="inner"><span class="visually-hidden">Slide '+index+'</span></span></button>';
            },
            type: 'bullets',
            bulletClass: 'stats-slider__pagination-bullet',
            bulletActiveClass: 'stats-slider__pagination-bullet-active',
            bulletElement: 'button',
        },
        speed: 2000,
        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        },
    });
}

function setHeight(slideElement) {
    var backgroundNumber = slideElement.querySelector('.stats-slider__bgnum'),
        backgroundNumberHeight = backgroundNumber.clientHeight,
        slideHeight = slideElement.clientHeight,
        pagination = slideElement.parentElement.querySelector('.stats-slider__pagination'),
        paginationHeight = pagination ? pagination.clientHeight : 0,
        heightToSet = 'auto';
    if(backgroundNumberHeight > slideHeight) {
        heightToSet = backgroundNumberHeight;

        if(window.innerWidth < 992) {
            heightToSet = backgroundNumberHeight + paginationHeight;
        }
    }
    return heightToSet;
}

function getDirection() {
    var direction = window.innerWidth >= 992 ? 'vertical' : 'horizontal';

    return direction;
}